import { useContext, useState } from 'react';
import { MODALS } from '../../../../../constants';
import { Context } from '../../../../../context/AppContext';

const useModalLogic = ({ exitAnimationDuration }) => {
  const {
    modal: { modals, hideModal },
  } = useContext(Context);
  const showModal = modals[MODALS.SEARCH_AUTOSUGGEST].show;
  // `show` is used to initate animations, while `showModal` is used to add/remove the modal from DOM

  const [show, setShow] = useState(showModal);

  /**
   * Close the modal. Wait until animations have finished before removing modal from DOM
   */
  const closeModal = () => {
    setShow(false);
    setTimeout(
      () => hideModal(MODALS.SEARCH_AUTOSUGGEST),
      exitAnimationDuration
    );
  };

  return {
    handleBlackoutClick: closeModal,
    handleCloseModalButtonClick: closeModal,
    show,
  };
};

export default useModalLogic;
